/** The offer image served from the platform's own origin, so the browser may read the bytes for sharing. */
export function offerImageProxyUrl(
  apiBase: string,
  clientUid: string,
  contactUid?: string | null,
): string {
  const url = new URL('/api/referral/offer-image-file/', apiBase);
  url.searchParams.set('clientuid', clientUid);
  if (contactUid) url.searchParams.set('contactuid', contactUid);
  // A fresh query each time keeps a stale cached copy out of the share sheet.
  url.searchParams.set('share-cache-bust', Date.now().toString());
  return url.toString();
}
